import { AdminSubscriptionCompanyAddress } from "./AdminSubscriptionCompanyAddress"
import { AdminSubscriptionCompanyCatalogMetrics } from "./AdminSubscriptionCompanyCatalogMetrics"
import { AdminSubscriptionCompanyConfiguration } from "./AdminSubscriptionCompanyConfiguration"
import { AdminSubscriptionCompanyContact } from "./AdminSubscriptionCompanyContact"
import { AdminSubscriptionCompanyCourier } from "./AdminSubscriptionCompanyCourier"
import { AdminSubscriptionCompanyCustomer } from "./AdminSubscriptionCompanyCustomer"
import { AdminSubscriptionCompanyEmployee } from "./AdminSubscriptionCompanyEmployee"
import { AdminSubscriptionCompanyProfile } from "./AdminSubscriptionCompanyProfile"

export class AdminSubscriptionMonitoringDetails {
  companyId: number

  companyName: string

  isTestOrDemoCompany: boolean

  profile: AdminSubscriptionCompanyProfile

  address: AdminSubscriptionCompanyAddress

  contact: AdminSubscriptionCompanyContact

  configuration: AdminSubscriptionCompanyConfiguration

  catalogMetrics: AdminSubscriptionCompanyCatalogMetrics

  customers: AdminSubscriptionCompanyCustomer[]

  employees: AdminSubscriptionCompanyEmployee[]

  couriers: AdminSubscriptionCompanyCourier[]

  constructor(data: Partial<AdminSubscriptionMonitoringDetails> = {}) {
    this.companyId = data.companyId ?? 0

    this.companyName = data.companyName ?? ""

    this.isTestOrDemoCompany = data.isTestOrDemoCompany ?? false

    this.profile = new AdminSubscriptionCompanyProfile(data.profile)

    this.address = new AdminSubscriptionCompanyAddress(data.address)

    this.contact = new AdminSubscriptionCompanyContact(data.contact)

    this.configuration = new AdminSubscriptionCompanyConfiguration(data.configuration)

    this.catalogMetrics = new AdminSubscriptionCompanyCatalogMetrics(data.catalogMetrics)

    this.customers = data.customers?.map((item) => new AdminSubscriptionCompanyCustomer(item)) ?? []

    this.employees = data.employees?.map((item) => new AdminSubscriptionCompanyEmployee(item)) ?? []

    this.couriers = data.couriers?.map((item) => new AdminSubscriptionCompanyCourier(item)) ?? []
  }
}
